console.log('🚀 main.tsx starting execution...');
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import App from './app/App';
import './styles/index.css';

// Theme management is now handled dynamically in App.tsx via ThemeManager component

// Add error boundary for initialization and runtime errors
window.addEventListener('error', (event) => {
  // Check for chunk load errors (failed dynamic imports due to deployment updates)
  const isChunkError = event.error?.message?.includes('Failed to fetch dynamically imported module') ||
    event.error?.message?.includes('Importing a module script failed');

  if (isChunkError) {
    const storageKey = 'chunk_load_error_retried';
    const hasRetried = sessionStorage.getItem(storageKey);

    if (!hasRetried) {
      console.log('🔄 Chunk load error detected, reloading page to fetch new version...');
      sessionStorage.setItem(storageKey, 'true');
      window.location.reload();
      return;
    }
  }

  console.error('🔴 Uncaught Error:', event.error);
  document.body.innerHTML = `
    <div style="padding: 20px; font-family: system-ui, -apple-system, sans-serif;">
      <h1 style="color: #dc2626;">Application Error</h1>
      <p style="color: #666;">An error occurred:</p>
      <pre style="background: #f3f4f6; padding: 15px; border-radius: 4px; overflow: auto; max-height: 300px;">${event.error?.message || 'Unknown error'}\n\n${event.error?.stack || ''}</pre>
      <p style="color: #666; margin-top: 20px;"><a href="javascript:location.reload()">Reload page</a></p>
    </div>
  `;
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('🔴 Unhandled Promise Rejection:', event.reason);
  document.body.innerHTML = `
    <div style="padding: 20px; font-family: system-ui, -apple-system, sans-serif;">
      <h1 style="color: #dc2626;">Application Error (Async)</h1>
      <p style="color: #666;">An error occurred:</p>
      <pre style="background: #f3f4f6; padding: 15px; border-radius: 4px; overflow: auto; max-height: 300px;">${event.reason?.message || String(event.reason)}</pre>
      <p style="color: #666; margin-top: 20px;"><a href="javascript:location.reload()">Reload page</a></p>
    </div>
  `;
});

try {
  const rootElement = document.getElementById('root');

  if (!rootElement) {
    throw new Error('Failed to find the root element. The app cannot start.');
  }

  console.log('✅ Root element found, creating React root...');
  const root = ReactDOM.createRoot(rootElement);

  console.log('✅ React root created, rendering app...');
  root.render(
    <StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </StrictMode>
  );
  console.log('✅ App render initiated');
} catch (error) {
  console.error('❌ Fatal error during app initialization:', error);
  // Display error to user
  document.body.innerHTML = `
    <div style="padding: 20px; font-family: system-ui, -apple-system, sans-serif;">
      <h1 style="color: #dc2626;">Application Failed to Start</h1>
      <p style="color: #666;">An error occurred while initializing the application:</p>
      <pre style="background: #f3f4f6; padding: 15px; border-radius: 4px; overflow: auto;">${error instanceof Error ? error.message : String(error)}</pre>
      <p style="color: #666; margin-top: 20px;">Please try refreshing the page. If the problem persists, contact support.</p>
    </div>
  `;
  throw error;
}